import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../contexts/UserContext";
import { useContext, useEffect } from "react";
import { client } from "../api/network";

const useAxios = () => {

    const { destroySession } = useContext(UserContext);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const responseInterceptor = client.interceptors.response.use(
            response => response,
            (error) => {
                if(error?.response?.status === 401) {
                    destroySession();
                    navigate('/login', {state: {redirect: location.pathname}});
                } else return Promise.reject(error);
            }
        );

        return () => {
            client.interceptors.response.eject(responseInterceptor);
        }
    }, []);

    return client;
}

export default useAxios;